import { Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ICoreLayoutTranslationService } from '../tokens';
import { resolveCoreTranslateLang } from '../../i18n/ngx-translate.config';

@Injectable()
export class CoreLayoutNgxTranslationService implements ICoreLayoutTranslationService {
  detectChange: Observable<LangChangeEvent> = this.translate.onLangChange;

  constructor(private translate: TranslateService) {
    const initial =
      localStorage.getItem('lang') || sessionStorage.getItem('language') || sessionStorage.getItem('lang') || 'en';

    const normalized = resolveCoreTranslateLang(initial);
    this.translate.setDefaultLang(normalized);
    this.translate.use(normalized);
  }

  pt(key: string, args?: any[]): string {
    const translation = this.translate.instant(key, args as any);
    return typeof translation === 'string' && translation ? translation : key;
  }

  lang(pipeId: string): void {
    this.translate.use(resolveCoreTranslateLang(pipeId));
  }
}
